import axios from 'axios';
import { REQUEST_URL } from '../config/urls';

const requisitar = () => {
  return {
    type: 'REQUISITAR_FORMANDO',
  };
};

const erro = (erro) => {
  return {
    type: 'ERRO_FORMANDO',
    erro,
  };
};

const obterTodos = (formandos) => {
  return {
    type: 'OBTER_TODOS_FORMANDOS',
    formandos,
  };
};

const novoFormando = (formando) => {
  return {
    type: 'NOVO_FORMANDO',
    formando,
  };
};

const alterarFormando = (formando) => {
  return {
    type: 'ALTERAR_FORMANDO',
    formando,
  };
};

const removerFormando = (id) => {
  return {
    type: 'REMOVER_FORMANDO',
    id,
  };
};

const obterPeloContrato = (formandos) => {
  return {
    type: 'OBTER_PELO_CONTRATO',
    formandos,
  };
};
// FUNÇÕES EXPORTADAS

export const adicionarFormando = (formando) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .post(`${REQUEST_URL}/formandos`, formando)
      .then((response) => {
        dispatch(novoFormando(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const editarFormandoEUsuario = (formando) => {
  return (dispatch) => {
    dispatch(requisitar());
    formando.ip = localStorage.getItem('ip');
    return axios
      .patch(`${REQUEST_URL}/usuarios/${formando.usuario}`, {
        login: formando.email,
        email: formando.email,
      })
      .then(() => {
        delete formando.usuario;
        axios
          .patch(`${REQUEST_URL}/formandos/${formando.id}`, formando)
          .then((response) => {
            dispatch(alterarFormando(response.data));
          })
          .catch((error) => {
            dispatch(erro(error.response.data.error));
          });
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const editarFormando = (formando) => {
  return (dispatch) => {
    dispatch(requisitar());
    formando.ip = localStorage.getItem('ip');
    return axios
      .patch(`${REQUEST_URL}/formandos/${formando.id}`, formando)
      .then((response) => {
        dispatch(alterarFormando(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const deletarFormando = (id) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .delete(`${REQUEST_URL}/formandos/${id}`)
      .then(() => {
        dispatch(removerFormando(id));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const deletarFormandoEUsuario = (formando) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .delete(`${REQUEST_URL}/formandos/${formando.id}`)
      .then(() => {
        axios.delete(`${REQUEST_URL}/usuarios/${formando.usuario.id}`);
        dispatch(removerFormando(formando.id));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterFormandos = () => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .get(`${REQUEST_URL}/formandos`)
      .then((response) => {
        dispatch(obterTodos(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterFormandosPeloContrato = (contratoId) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .get(
        `${REQUEST_URL}/formandos?filter={"where":{"contrato":${contratoId}},"include":["itens","usuario", "formandos"],"order":"nome ASC"}`
      )
      .then((response) => {
        dispatch(obterPeloContrato(response.data));
      })
      .catch((error) => {
        dispatch(erro(error));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/FormandoActions.js